import { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { trackRoute } from './index';

class RouteTracker extends Component {
    static propTypes = {
        location: PropTypes.object.isRequired
    };

    componentDidMount() {
        trackRoute(this.props.location.pathname);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            trackRoute(this.props.location.pathname);
        }
    }

    render() {
        return null;
    }
}

RouteTracker.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired
    }).isRequired
};

export default withRouter(RouteTracker);



// WEBPACK FOOTER //
// ./app/analytics/route-tracker.js